export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./header.menu.vue?vue&type=template&id=84bdb2a4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.menu.vue?vue&type=template&id=84bdb2a4&scoped=true&
// module id = 110
// module chunks = 16